import { render, staticRenderFns } from "./EditorCardPanel.vue?vue&type=template&id=f8be7824&scoped=true"
import script from "./EditorCardPanel.vue?vue&type=script&lang=js"
export * from "./EditorCardPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorCardPanel.vue?vue&type=style&index=0&id=f8be7824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8be7824",
  null
  
)

export default component.exports